export const MARKET_NEWS = "MARKET_NEWS";
export const MARKET_NEWS_ERROR = "MARKET_NEWS_ERROR";
export const MARKET_NEWS_HIDE_ERROR = "MARKET_NEWS_HIDE_ERROR";
export const MARKET_NEWS_START_LOADER = "MARKET_NEWS_START_LOADER";
export const MARKET_NEWS_STOP_LOADER = "MARKET_NEWS_STOP_LOADER";
